import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import { ReactComponent as LogoDark } from "../../../assets/images/logos/logo-dark.svg";
// import { ReactComponent as LogoLight } from "../../../assets/images/logos/logo-white.svg";
import { ReactComponent as Logo } from "../../../assets/images/logo.svg";
// import { ReactComponent as Logo } from "../../../assets/images/logos/logo-ct-dark.svg";

const LogoIcon = () => {
  const customizer = useSelector((state) => state.CustomizerReducer);
  return (
    <Link underline="none" to="/">
      {customizer.activeMode === "dark" ? <Logo /> : <Logo style={{justifySelf:"center",display:"flex",scale:"150%",color:"#FB9678"}}/>}
    </Link>
  );
};

export default LogoIcon;
